import { dispatch } from "../../state/store";
import { pushMarkets } from "../../state/ducks";

import httpClient from "../httpClient";

const apiUrl = process.env.REACT_APP_API_URL;

const getRequestData = async (endpoint) => {
  return `${apiUrl}/market-management/${endpoint}`;
};

const fetchMarkets = async () => {
  const url = await getRequestData("get-markets");

  const data = await httpClient.get(url);

  dispatch(
    pushMarkets(
      data?.data?.map((market) => {
        return {
          ...market,
          id: market.market
        };
      })
    )
  );
};

const createMarket = async (market) => {
  const url = await getRequestData("create-market");

  return await httpClient.post(url, { data: market });
};

const updateMarket = async (market) => {
  const url = await getRequestData("update-market");

  return await httpClient.put(url, { data: market });
};

const deleteMarket = async (market) => {
  const url = await getRequestData("delete-market");

  return await httpClient.remove(url, { data: { market: market.market } });
};

const marketsService = { fetchMarkets, createMarket, updateMarket, deleteMarket };

export default marketsService;
